"use client";

import type { PlaceholderResource } from "../../types/injectables";

import { AdvertorySlot } from "../Advertory/AdvertorySlot";
import { useAdvertory } from "../Advertory/AdvertoryContext";
import { getAdvertoryTargetId } from "../Advertory/getAdvertoryTargetId";

const InjectablePlaceholder = ({
  resource,
  feedLayoutType,
}: {
  resource: PlaceholderResource;
  feedLayoutType?: "top" | "latest";
}) => {
  const { deviceType, enabled, isAdvertoryPage } = useAdvertory();

  if (!isAdvertoryPage || !enabled) return null;

  const targetId = getAdvertoryTargetId(resource, deviceType);
  if (!targetId) return null;

  return (
    <AdvertorySlot
      targetId={targetId}
      device={deviceType}
      nativeLayout={feedLayoutType === "latest" ? "small" : "large"}
    />
  );
};

export { InjectablePlaceholder as InjectablePlaceholderComponent };
